import { render } from "./FormActionsBuilder.vue?vue&type=template&id=98a23292&ts=true"
import script from "./FormActionsBuilder.vue?vue&type=script&lang=ts"
export * from "./FormActionsBuilder.vue?vue&type=script&lang=ts"

import "./FormActionsBuilder.vue?vue&type=style&index=0&id=98a23292&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__